import {
  Card,
  Col,
  Row,
} from "antd";

import Echart from "../components/chart/EChart";

import '../assets/css/statisticChart.css'

const StChart = (props) => {
  return (
    <>
      <div className="layout-content">
        <Row gutter={[24, 0]}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="mb-24">
            <Card bordered={false} className="criclebox h-full">
              <Echart {...props} type='12M' />
            </Card>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="mb-24">
            <Card bordered={false} className="criclebox h-full">
              <Echart {...props} type='7D' />
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default StChart;